module.exports = __webpack_public_path__ + "img/mobile-phone.c76db702.svg";